"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LobbyCommands = exports.lobbyReducer = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = null;
_a = (0, toolkit_1.createSlice)({
    name: "lobby",
    initialState,
    reducers: {
        connectToLobby: (state, action) => (Object.assign({}, action.payload)),
        updatePlayers: (state, action) => {
            if (!state) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { players: action.payload.players });
        },
        updateSettings: (state, action) => {
            if (!state) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { settings: action.payload.settings });
        },
    },
}), exports.lobbyReducer = _a.reducer, exports.LobbyCommands = _a.actions;
